
import React from "react";
import {SectionBoxes} from "../../contenful/types";
import Markdown from 'react-markdown'
import  './styles/SectionBoxes.scss';
import { Link } from "react-router-dom";

interface BoxProps {
    backgroundColorBox?: string;
    iconUrl?: string;
    iconWidth?: string;
    iconHeight?: string;
    textColor?: string;
    title?: string;
    text?: any;
    classList: string;
    iconLeft?: string;
    borderColorBox?: string;
    link?: string;
}


const Box = (props: BoxProps) => {
    return (
        <div className={`${"box"} ${props.classList}`} style={{ background: `${props.backgroundColorBox}`, borderColor: `${props.borderColorBox}` }}>
        <div className={`contentBox ${props.iconLeft}`}>
          {props.link && props.link.trim() ? (
            <Link to={props.link}>
              <img alt="icon" src={props.iconUrl} width={props.iconWidth} height={props.iconHeight} className="icon" />
            </Link>
          ) : (
            <img alt="icon" src={props.iconUrl} width={props.iconWidth} height={props.iconHeight} className="icon" />
          )}
          <div className={"textWrap"}>
            <h5 className={"title"} style={{ color: `${props.textColor}` }}>
              {props.title}
            </h5>
            <div className={"text"} style={{ color: `${props.textColor}` }}>
              {props.text}
            </div>
          </div>
        </div>
      </div>
    )
}


interface Props {
    section: SectionBoxes;
    mobile: boolean;
}

const SectionBoxesComponent = (props: Props) => {
    const {name, backgroundColorSection, backgroundImage, title1, icon1, text1, backgroundColorBox1,
        textColor, backgroundColorBox2, icon2, title2, text2, backgroundColorBox3, icon3, title3,
        text3, backgroundColorBox4, icon4, title4, text4, borderColor, iconLeft, backgroundGradientSection, circleBox, borderColorBox, cssClassName, link1, link2, link3, link4} = props.section
        const bgUrl = backgroundImage ? `url(${backgroundImage.fields.file.url})` : backgroundGradientSection
        const isIconLeft = iconLeft ?  `iconLeft` : ``
        const isCircleBox = circleBox ? 'circle' : 'sqaure'
        const isBorderColor = borderColorBox ? borderColorBox : 'transparent'
        const classNameContentful = cssClassName ? cssClassName : ``
    return (
        <div className={`section-boxes ${"section"} ${name} ${classNameContentful}`}
        style={{backgroundColor: backgroundColorSection,
        backgroundImage: bgUrl,
        borderColor: borderColor}}>
            <div className="container">
                <div className={`boxItemWrap ${isCircleBox}`}>
                    {title1 || icon1 || text1 ?
                        <Box backgroundColorBox={backgroundColorBox1}
                            link={link1}
                            iconUrl={icon1 && icon1.fields.file.url}
                            iconWidth={icon1 && icon1.fields.file.details.image.width}
                            iconHeight={icon1 && icon1.fields.file.details.image.height}
                            textColor={textColor}
                            title={title1}
                            text={<Markdown children={text1} />}
                            classList={`box-1`}
                            iconLeft={isIconLeft}
                            borderColorBox={isBorderColor} />
                    : null}

                    {title2 || icon2 || text2 ?
                        <Box backgroundColorBox={backgroundColorBox2}
                        link={link2}
                        iconUrl={icon2 && icon2.fields.file.url}
                            iconWidth={icon1 && icon1.fields.file.details.image.width}
                            iconHeight={icon1 && icon1.fields.file.details.image.height}
                        textColor={textColor}
                        title={title2}
                        text={<Markdown children={text2} />}
                        classList={`box-2`}
                        iconLeft={isIconLeft}
                        borderColorBox={isBorderColor} />
                    : null}

                    {title3 || icon3 || text3 ?
                        <Box backgroundColorBox={backgroundColorBox3}
                        link={link3}
                        iconUrl={icon3 && icon3.fields.file.url}
                            iconWidth={icon1 && icon1.fields.file.details.image.width}
                            iconHeight={icon1 && icon1.fields.file.details.image.height}
                        textColor={textColor}
                        title={title3}
                        text={<Markdown children={text3} />}
                        classList={`box-3`}
                        iconLeft={isIconLeft}
                        borderColorBox={isBorderColor}/>
                    : null}

                    {title4 || icon4 || text4 ?
                        <Box backgroundColorBox={backgroundColorBox4}
                        link={link4}
                        iconUrl={icon4 && icon4.fields.file.url}
                            iconWidth={icon1 && icon1.fields.file.details.image.width}
                            iconHeight={icon1 && icon1.fields.file.details.image.height}
                        textColor={textColor}
                        title={title4}
                        text={<Markdown children={text4} />}
                        classList={`box-4`}
                        iconLeft={isIconLeft}
                        borderColorBox={isBorderColor}/>
                    : null}
                </div>
            </div>
        </div>
    )
}

export default SectionBoxesComponent;